<div class="heatmap-wrapper" data-testid="subcriteria-attribute-scores-heatmap">
  <div class="heatmap-scroll">
    <div
      echarts
      [options]="chartOptions()"
      [style.height.px]="chartHeight()"
      class="heatmap-chart"
    ></div>
  </div>
</div>
